import React from 'react'
import { connect } from 'react-redux'
import DoorEntity from 'components/DoorEntity'
import NetworkCloset from 'components/NetworkCloset'
import WiredDevice from 'components/WiredDevice'
import Wire from 'components/Wire'

const mapStateToProps = ({ entities, createdAt }) => ({ entities, createdAt })

class EntitiesContainer extends React.Component {
  render() {
    const { entities, createdAt } = this.props

    return (
      <div>
        { entities.doorControllers.allIds.map(id => <DoorEntity key={'doorControllerComp' + createdAt + id} id={id} isController />) }
        { entities.doors.allIds.map(id => <DoorEntity key={'doorComp' + createdAt + id} id={id} />) }
        { entities.networkClosets.allIds.map(id => <NetworkCloset key={'networkClosetComp' + createdAt + id} id={id} />) }
        { entities.wiredDevices.allIds.map(id => <WiredDevice key={'wiredDeviceComp' + createdAt + id} id={id} />) }
        { Object.values(entities.wires.byId).map(wire => <Wire key={'wireComp' + createdAt + wire.id} id={wire.id} { ... { ...wire } } />) }
      </div>
    )
  }
}

export default connect(mapStateToProps)(EntitiesContainer)



// WEBPACK FOOTER //
// ./src/components/EntitiesContainer/index.js